import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { createCallbackActionCreator } from '../../Stream/helpers';
export var initialFetch = createAction(actionKey + "/FETCH_INITIAL", function () { return ({}); });
export var fetchMoreWatchedGroups = createCallbackActionCreator(actionKey + "/FETCH_WATCHED_GROUPS");
export var fetchMoreRecommendedGroups = createCallbackActionCreator(actionKey + "/FETCH_RECOMMENDED_GROUPS");
export var togglePinGroup = createAction(actionKey + "/TOGGLE_PIN", function (groupId, isPinnedAfter) { return ({
    groupId: groupId,
    isPinnedAfter: isPinnedAfter,
}); });
export var toggleWatchGroup = createAction(actionKey + "/TOGGLE_WATCH", function (groupId, isWatchingAfter) { return ({
    groupId: groupId,
    isWatchingAfter: isWatchingAfter,
}); });
export var unrecommendGroup = createAction(actionKey + "/UNRECOMMEND", function (groupId) { return ({ groupId: groupId }); });
//# sourceMappingURL=actions.js.map